<template>
    <div class="contacts-page">
        <div class="container">
            <div class="page-title">
                <h1>{{pageSetup.page_title}}</h1>
            </div>
            <div class="office-cards">
                <div class="card" v-for="item in pageSetup.office_card">
                    <div class="card-title">
                        <h3>{{item.name}}</h3>
                    </div>
                    <div class="office-info" v-if="item.phones != null && item.phones.length != 0">
                        <svgIcon name="mobile" class="icon-mobile"/>
                        <div class="info">
                            <strong>{{pageSetup.syntax.phone_title}}</strong>
                            <p v-for="elem in item.phones">
                                <a :href="'tel:' + elem.number">{{elem.number}}</a>
                            </p>
                        </div>
                    </div>
                    <div class="office-info" v-if="item.email != null && item.email != ''">
                        <svgIcon name="mail" class="icon-mail"/>
                        <div class="info">
                            <strong>Email</strong>
                            <p>{{item.email}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <contactsSales></contactsSales> -->
    </div>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'contacts--page',
        components: {
            svgIcon,
        },
        data () {
            return {
                titlePage: 'Контакты',
                loadComponent: false,
            }
        },
        computed: mapGetters({
            pageSetup: 'loadContactsPage',
            titleSite: 'loadSiteTitle',
            // setup: 'loadPageSetUp',
            // currentCity: 'loadCurrentCity',
            // currentCityArr: 'loadCurrentCityArr',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.contactsPage != null) {
                next(vm => {
                    vm.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getContactsPageData').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getContactsPageData');
            document.body.dataset.page = 'contacts';
        },
        created () {
            // this.initYmapScript();
            // document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/contacts-page/contacts-page.scss';
    @import '@/styles/components/contacts-page/contacts-page-respond.scss';
    // @import '@/styles/respond/contacts/contacts-respond.scss';
</style>